
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","data-name":"vuesax/twotone/messages-3"}},[_c('path',{attrs:{"d":"M9.25 1.25h8.5a4.971 4.971 0 013.612 1.388A4.971 4.971 0 0122.75 6.25v5.1a5 5 0 01-1.39 3.61 4.811 4.811 0 01-2.86 1.34v1.11a1.606 1.606 0 01-1.6 1.605 1.576 1.576 0 01-.883-.272l-.967-.638a.75.75 0 01-.307-.835 2.9 2.9 0 00.1-.8V12.4a2.459 2.459 0 00-2.653-2.65H5.4c-.111 0-.223.009-.342.018a.751.751 0 01-.567-.2.75.75 0 01-.241-.548V6.25a4.971 4.971 0 011.388-3.612A4.971 4.971 0 019.25 1.25zm7.65 16.265a.107.107 0 00.1-.105V15.6a.75.75 0 01.75-.75 3.475 3.475 0 002.55-.95 3.475 3.475 0 00.95-2.55v-5.1a3.28 3.28 0 00-3.5-3.5h-8.5a3.28 3.28 0 00-3.5 3.5v2h6.44a4.123 4.123 0 013 1.155 4.124 4.124 0 011.155 3v4.07a4.9 4.9 0 01-.043.663l.546.361.008.005a.076.076 0 00.044.011z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M5.4 8.25h6.79a4.124 4.124 0 013 1.155 4.124 4.124 0 011.155 3v4.065a4.4 4.4 0 01-.156 1.206 3.9 3.9 0 01-3.999 2.944H9.7L6.87 22.5a1.409 1.409 0 01-.8.248 1.428 1.428 0 01-1.42-1.428v-.756a3.992 3.992 0 01-2.24-1.094 4.131 4.131 0 01-1.16-3V12.4a4.18 4.18 0 011.008-2.838A3.993 3.993 0 014.93 8.273h.012c.136-.011.289-.023.458-.023zm6.79 10.87a2.4 2.4 0 002.543-1.82l.007-.026a2.9 2.9 0 00.1-.8V12.4a2.459 2.459 0 00-2.65-2.65H5.4c-.109 0-.22.008-.336.017A2.426 2.426 0 002.75 12.4v4.07a2.667 2.667 0 00.72 1.94 2.653 2.653 0 001.93.71.75.75 0 01.75.75v1.309l2.9-1.933a.75.75 0 01.416-.126z"}})])])
          )
        }
      }
    